// client/src/components/app/common/IdleTimeoutWarning.js
// FDA 21 CFR Part 11 compliance: Idle session timeout warning overlay.
// Renders when idleWarningVisible is true from ActivityTrackingContext.

import React from 'react';
import styled from 'styled-components';
import { useActivityTracking } from '../context/ActivityTrackingContext';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;

const WarningBox = styled.div`
  background: ${({ theme }) => theme.colors.neutral.background.light};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  padding: ${({ theme }) => theme.spacing[8]};
  max-width: 420px;
  width: 90%;
  text-align: center;
  box-shadow: ${({ theme }) => theme.shadows.xl};
`;

const Title = styled.h3`
  margin: 0 0 ${({ theme }) => theme.spacing[3]} 0;
  color: ${({ theme }) => theme.colors.status.warning};
  font-size: ${({ theme }) => theme.typography.fontSizes.lg};
`;

const Message = styled.p`
  margin: 0 0 ${({ theme }) => theme.spacing[6]} 0;
  color: ${({ theme }) => theme.colors.neutral.text.secondary};
  font-size: ${({ theme }) => theme.typography.fontSizes.sm};
  line-height: 1.5;
`;

const Countdown = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSizes['3xl']};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.status.error};
  margin-bottom: ${({ theme }) => theme.spacing[6]};
`;

const StayButton = styled.button`
  background: ${({ theme }) => theme.colors.primary.main};
  color: ${({ theme }) => theme.colors.primary.contrast};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  padding: ${({ theme }) => `${theme.spacing[3]} ${theme.spacing[8]}`};
  font-size: ${({ theme }) => theme.typography.fontSizes.base};
  font-weight: 600;
  cursor: pointer;
  &:hover { background: ${({ theme }) => theme.colors.primary.light}; }
`;

const IdleTimeoutWarning = () => {
  const { idleWarningVisible, dismissIdleWarning, idleSecondsRemaining } = useActivityTracking();

  if (!idleWarningVisible) return null;

  return (
    <Overlay onClick={dismissIdleWarning}>
      <WarningBox onClick={(e) => e.stopPropagation()}>
        <Title>Session Timeout Warning</Title>
        <Message>
          Your session will expire due to inactivity.
          Click below or interact with the page to stay logged in.
        </Message>
        <Countdown>{idleSecondsRemaining}s</Countdown>
        <StayButton onClick={dismissIdleWarning}>
          Stay Logged In
        </StayButton>
      </WarningBox>
    </Overlay>
  );
};

export default IdleTimeoutWarning;
